import { chainWalk } from "./Util";

export const getContainerId = (data) => {
  return chainWalk(() => {
    const parsedData = JSON.parse(data);

    if (parsedData && parsedData.cids && parsedData.cids.pkey) {
      return parsedData.cids.pkey;
    }

    return null;
  }, data);
};



// WEBPACK FOOTER //
// ./src/components/util/ScannerUtils.js